/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { AsyncPipe } from '@angular/common';
import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
    name: 'translateRoles',
    standalone: false
})
export class TranslateRolesPipe implements PipeTransform, OnDestroy {

  private asyncPipe: AsyncPipe;

  constructor(private translateService: TranslateService, private changeDetectorRef: ChangeDetectorRef) {
    this.asyncPipe = new AsyncPipe(changeDetectorRef);
  }

  transform(value: any, args?: any): string {
    if (!Array.isArray(value) || value.length === 0) {
      return value;
    }
    const translateRolesObservable = forkJoin(value.map(role =>
      this.translateService.get('user.roles.' + role)
    )).pipe(
      map(translatedRoles => translatedRoles.join(', '))
    );

    return this.asyncPipe.transform(translateRolesObservable);
  }

  ngOnDestroy(): void {
    this.asyncPipe.ngOnDestroy();
  }
}
